// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vs-tabs-active-bar{bottom:-2px;height:2px;position:absolute;-webkit-transition:all .2s;transition:all .2s}.vs-tabs-scroller{margin-bottom:-30px;overflow-x:auto;padding-bottom:30px;scroll-behavior:smooth}.vs-tabs-header{overflow:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
